import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-shared-selftest-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-selftest-form.component.html',
    styleUrls: ['./shared-selftest-form.component.scss'],
    standalone: false
})
export class SharedSelftestFormComponent {
  #isSubmitted = signal(false);
  #annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType | null;
  selftestForm = new FormGroup(
    {
      ignore: new FormControl(false),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.AnnotationEntityModels.SelfTestSchema.pick({
          ignore: true
        }),
      ),
      updateOn: 'change',
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Marker
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((marker) => {
      this.#annotation = structuredClone(marker);
      if (this.#annotation) {
        this.selftestForm.reset({
          ignore: this.#annotation.selfTest?.ignore || false,
        });
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.selftestForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const annotation = assign(this.#annotation, {selfTest: { ignore: this.selftestForm.value.ignore } });
    this.slideAuthorFacade.requestUpdateAnnotation(annotation, 'history.free_form_update_selftest').subscribe({
      error: (result) => {
        this.alertControlFacade.requestAddError(result);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
